<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`编辑发票号`"
    width="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="报告编号">
            <span class="code-span" v-for="(item, index) in activeRows" :key="index">{{ item.reportCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="发票号" prop="invoiceCode">
            <el-input v-model.trim="editForm.invoiceCode" placeholder="请输入发票号" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { editReportInvoiceCodeBatch } from '@/api/invoice';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {
        invoiceCode: ''
      },
      rules: {
        invoiceCode: [{ required: true, message: '请输入发票号', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const params = { ids: this.activeRows.map(item => item.id).join(','), ...this.editForm };

          try {
            await editReportInvoiceCodeBatch(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.code-span {
  display: inline-block;
  margin-right: 10px;
}
</style>
